/* eslint-disable react-hooks/exhaustive-deps */
import { withRouter } from "../_shared/withRouter";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import Header from "../template/_common/header";
import SidebarComponent from "../template/admin/sidebarComponent";
import SidebarArrow from "../template/_common/sidebarArrow";
import InputComponent from "../template/_common/inputComponent";
import ConfirmationModal from "../template/_common/confirmModal";
import PaginationOwn from "../template/_common/ownPagination";
import { Select, FormControl, MenuItem, InputLabel } from "@mui/material";
import { globalAlert, globalLoader } from "../actions/commonActions";
import { logOut } from "../_shared/commonFunction";
import { StatusBadge } from "./lmsOverview";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  lmsListRegistrationsApi,
  lmsReviewRegistrationApi,
  lmsResendInviteApi,
  lmsResendRegistrationInviteApi,
} from "./_lmsActions";

const STATUS_OPTIONS = ["pending", "approved", "rejected", "all"];

const LmsRegistrations = (props) => {
  const { t } = useTranslation();
  const [navbarToggle, setNavbarToggle] = useState(false);
  const [allowView, setAllowView] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [statusFilter, setStatusFilter] = useState("pending");
  const [pageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [reviewTarget, setReviewTarget] = useState(null); // { request, action }
  const [showProfileModal, setShowProfileModal] = useState(false);
const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    callBasicApi();
  }, [currentPage, pageSize, statusFilter]);

  const callBasicApi = async (
    page = currentPage,
    filters = { searchValue, statusFilter }
  ) => {
    try {
      globalLoader(true);
      const params = new URLSearchParams({
        page: String(page),
        limit: String(pageSize),
        status: filters.statusFilter,
      });
      const search = filters.searchValue.trim();
      if (search) params.set("search", search);
      const query = `?${params.toString()}`;
      const res = await lmsListRegistrationsApi(query);
      if (res?.data?.status === 200) {
        const data = res?.data?.data || {};
        setDataList(data?.list || data?.registrations || []);
        setTotalCount(
          data?.pagination?.total ??
            data?.totalCount ??
            data?.total ??
            (data?.list || data?.registrations || []).length
        );
        setAllowView(true);
      } else {
        globalAlert("error", res?.data?.message);
      }
      globalLoader(false);
    } catch (error) {
      globalAlert("error", error?.response?.data?.message);
      if (error?.response?.data?.status === 401) {
        logOut(props?.history, "/admin/login");
      }
      globalLoader(false);
    }
  };

  const searchFilter = (ev) => {
    ev.preventDefault();
    const filters = { searchValue, statusFilter };
    if (currentPage !== 1) setCurrentPage(1);
    else callBasicApi(1, filters);
  };

  const handleStatusFilter = (value) => {
    setStatusFilter(value);
    if (currentPage !== 1) setCurrentPage(1);
  };

  const goToPageFunc = (val, data) => {
    if (data === "prev" && currentPage > 1) setCurrentPage(currentPage - 1);
    else if (data === "next" && currentPage < Math.ceil(totalCount / pageSize))
      setCurrentPage(currentPage + 1);
    else if (val?.target?.value) setCurrentPage(Number(val.target.value));
  };

  const askReview = (request, action) => {
    setReviewTarget({ request, action });
    setConfirmOpen(true);
  };

  const confirmReview = async (val) => {
    if (val && reviewTarget) {
      try {
        globalLoader(true);
        const { request, action } = reviewTarget;
        const obj = { action };
        if (action === "reject")
          obj.rejectReason = t("admin.lms.registrations.defaultRejectReason");
        const res = await lmsReviewRegistrationApi(
          request?._id || request?.requestId,
          obj
        );
        if (res?.data?.status === 200) {
          globalAlert("success", res?.data?.message);
          callBasicApi();
        } else {
          globalAlert("error", res?.data?.message);
          globalLoader(false);
        }
      } catch (error) {
        globalAlert("error", error?.response?.data?.message);
        globalLoader(false);
      }
    }
    setConfirmOpen(false);
    setReviewTarget(null);
  };
  const viewProfile = (user) => {
  setSelectedUser(user);
  setShowProfileModal(true);
};

const closeProfileModal = () => {
  setShowProfileModal(false);
  setSelectedUser(null);
};
  const learnerIdFromRegistration = (registration) =>
    registration?.learner?._id || registration?.learnerId || registration?.learner;

  const resendInvite = async (registration) => {
    try {
      globalLoader(true);
      const learnerId = learnerIdFromRegistration(registration);
      const res = learnerId
        ? await lmsResendInviteApi(learnerId)
        : await lmsResendRegistrationInviteApi(registration?._id || registration?.requestId);
      if (res?.data?.status === 200) {
        globalAlert("success", res?.data?.message);
      } else {
        globalAlert("error", res?.data?.message);
      }
      globalLoader(false);
    } catch (error) {
      globalAlert("error", error?.response?.data?.message);
      globalLoader(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>{t("admin.pageTitle.lmsRegistrations")} - eC-Card</title>
        <meta name="viewport" content="width=1200, initial-scale=1" />
      </Helmet>
      {allowView && (
        <div className="admin-portal">
          <Header roleType="admin" />
          <div className={`${navbarToggle ? "active" : ""} wrapper`}>
            <SidebarComponent
              navbarToggle={navbarToggle}
              roleType="admin"
              menu="lms"
              subMenu="lms-registrations"
            />
            <div className="main">
              <div className="main-wrapper lms-registrations-page">
                <div>
                  <p className="admin-banner">
                    {t("admin.lms.registrations.title")}
                  </p>
                </div>
                <SidebarArrow handleSidebarToggle={setNavbarToggle} />

                <div className="custom-search-wrapper px-3 pt-3">
                  <div className="d-flex flex-wrap position-relative admin-controls">
                    <div className="input-wrapper">
                      <form onSubmit={searchFilter} className="admin-search">
                        <div className="search-wrapper">
                          <InputComponent
                            placeholder={t(
                              "admin.lms.registrations.searchPlaceholder"
                            )}
                            label={t(
                              "admin.lms.registrations.searchPlaceholder"
                            )}
                            type="text"
                            name="search"
                            theme="admin"
                            value={searchValue}
                            handleCallback={(val) => setSearchValue(val)}
                          />
                        </div>
                        <button type="submit" className="btn secondary-btn">
                          {t("common.go")}
                        </button>
                      </form>
                    </div>
                    <div className="show-item-page filter-type form-own ml-3 form-report-group">
                      <FormControl variant="outlined" size="small">
                        <InputLabel id="lms-reg-status">
                          {t("common.status")}
                        </InputLabel>
                        <Select
                          labelId="lms-reg-status"
                          value={statusFilter}
                          onChange={(ev) => {
                            handleStatusFilter(ev.target.value);
                          }}
                          label={t("common.status")}
                          name="statusFilter"
                        >
                          {STATUS_OPTIONS.map((s) => (
                            <MenuItem value={s} key={s}>
                              {t(`admin.lms.status.${s}`, s)}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </div>

                {dataList?.length > 0 && (
                  <div className="container-fluid pt-1">
                    <div
                      className="px-3 col-12 pt-3"
                      style={{ borderTop: "2px solid #ebeef1" }}
                    >
                      <PaginationOwn
                        pageSize={pageSize}
                        changePageSize={(v) => {
                          setPageSize(v.target.value);
                          setCurrentPage(1);
                        }}
                        goToPage={goToPageFunc}
                        totalCount={totalCount}
                        currentPage={currentPage}
                        applicationType="registrations"
                      />
                    </div>
                  </div>
                )}

                {dataList?.length > 0 ? (
                  <div className="table-wrapper px-3 pt-3">
                    <div className="table-own table-responsive">
                      <table className="table table-striped table-hover table-admin">
                        <thead className="table-head">
                          <tr>
                            <th>{t("common.name")}</th>
                            <th>{t("common.email")}</th>
                            <th>{t("admin.lms.fields.organisation")}</th>
                            <th>{t("admin.lms.fields.district")}</th>
                            <th>{t("admin.lms.fields.jobTitle")}</th>
                            <th>{t("common.status")}</th>
                            <th>{t("common.actions")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dataList.map((r, i) => {
                            const status = (r?.status || "").toLowerCase();
                            const pending = status === "pending";
                            return (
                              <tr key={r?._id || r?.requestId || i}>
                                <td>{r?.firstName || r?.lastName ? `${r?.firstName ?? ""} ${r?.lastName ?? ""}`.trim() : "-"}</td>
                                <td>{r?.email || "-"}</td>
                                <td>{r?.learnerOrganisation || "-"}</td>
                                <td>{r?.district || "-"}</td>
                                <td>{r?.jobTitle || "-"}</td>
                                <td>
                                  <StatusBadge status={r?.status} t={t} />
                                </td>
                                  <td className="d-flex align-items-center flex-wrap gap-2">

  {/* View Profile */}
  <OverlayTrigger
    placement="top"
    overlay={<Tooltip id="tooltip-view">View Profile</Tooltip>}
  >
    <button
      type="button"
      className="btn btn-sm btn-warning lms-action-btn d-flex align-items-center"
      onClick={() => viewProfile(r)}
    >
      <i className="fas fa-user me-2"></i>
      <span>View Profile</span>
    </button>
  </OverlayTrigger>

  {status === "approved" && (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id="tooltip-resend">
          {t("admin.lms.learners.resendInvite")}
        </Tooltip>
      }
    >
      <button
        type="button"
        className="btn btn-sm btn-info lms-action-btn d-flex align-items-center"
        onClick={() => resendInvite(r)}
      >
        <i className="fas fa-paper-plane me-2"></i>
        <span>{t("admin.lms.learners.resendInvite")}</span>
      </button>
    </OverlayTrigger>
  )}

  {pending && (
    <>
      {/* Approve */}
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id="tooltip-approve">
            {t("admin.lms.registrations.approve")}
          </Tooltip>
        }
      >
        <button
          className="btn btn-sm btn-success d-flex align-items-center"
          onClick={() => askReview(r, "approve")}
        >
          <i className="fas fa-check me-2"></i>
          <span>{t("admin.lms.registrations.approve")}</span>
        </button>
      </OverlayTrigger>

      {/* Reject */}
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id="tooltip-reject">
            {t("admin.lms.registrations.reject")}
          </Tooltip>
        }
      >
        <button
          className="btn btn-sm btn-danger d-flex align-items-center"
          onClick={() => askReview(r, "reject")}
        >
          <i className="fas fa-times me-2"></i>
          <span>{t("admin.lms.registrations.reject")}</span>
        </button>
      </OverlayTrigger>
    </>
  )}

</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div className="px-3 pt-3">
                    <div className="no-data-available">
                      {t("common.noDataAvailable")}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {confirmOpen && (
        <ConfirmationModal
          open={confirmOpen}
          deleteInfo={[
            `${t("common.name")} : ${reviewTarget?.request?.name}`,
            `${t("common.email")} : ${reviewTarget?.request?.email}`,
          ]}
          description={
            reviewTarget?.action === "approve"
              ? t("admin.lms.registrations.confirmApprove")
              : t("admin.lms.registrations.confirmReject")
          }
          onCloseModal={confirmReview}
        />
      )}
      {showProfileModal && (
  <>
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered ">
        <div className="modal-content main-wrapper">
          <div className="modal-header admin-banner">
            <h5 className="modal-title ">User Profile</h5>
            <button
              type="button"
              className="btn-close btn-danger"
              onClick={closeProfileModal}
            ></button>
          </div>

          <div className="modal-body ">
            <div className="row">
              <div className="col-md-6 mb-3">
                <strong>Name:</strong>
                <div>{selectedUser?.firstName || "-"} {selectedUser?.lastName || "-"}</div>
              </div>

              <div className="col-md-6 mb-3">
                <strong>Email:</strong>
                <div>{selectedUser?.email || "-"}</div>
              </div>

              <div className="col-md-6 mb-3">
                <strong>Organisation:</strong>
                <div>{selectedUser?.learnerOrganisation || "-"}</div>
              </div>

              <div className="col-md-6 mb-3">
                <strong>Jobtitle</strong>
                <div>{selectedUser?.jobTitle || "-"}</div>
              </div>

              <div className="col-md-6 mb-3">
                <strong>Region:</strong>
                <div>{selectedUser?.serviceArea || "-"}</div>
              </div>

              <div className="col-md-6 mb-3">
                <strong>District:</strong>
                <div>{selectedUser?.district || "-"}</div>
              </div>

            </div>
          </div>

          <div className="modal-footer">
            <button
              className="btn btn-danger"
              onClick={closeProfileModal}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

    <div className="modal-backdrop fade show"></div>
  </>
)}
    </>
  );
};

export default withRouter(LmsRegistrations);
